import { useIntl } from 'react-intl';

interface Props {
  currentOrders: string;
  totalOrders: number;
  status?: string;
}

export function OrderReprocessButtonLabel({ currentOrders, totalOrders, status }: Props) {
  const { $t } = useIntl();

  const inProgress = status === 'IN_PROGRESS';
  const completed = status === 'COMPLETED';
  const isMultiple = totalOrders > 1;

  if (inProgress) {
    if (isMultiple) {
      return (
        <>
          {$t(
            {
              id: 'audit.aod.actions.orderReprocess.processing.multiple',
              defaultMessage: 'Reprocesando órdenes {currentOrders}',
            },
            {
              currentOrders: currentOrders.split(',').join(', '),
            },
          )}
        </>
      );
    }
    return (
      <>
        {$t(
          {
            id: 'audit.aod.actions.orderReprocess.processing',
            defaultMessage: 'Reprocesando orden {orderId}',
          },
          { orderId: currentOrders },
        )}
      </>
    );
  }

  if (completed) {
    if (isMultiple) {
      return (
        <>
          {$t(
            {
              id: 'audit.aod.actions.orderReprocess.completed.multiple',
              defaultMessage: 'Órdenes reprocesadas: {currentOrders}',
            },
            {
              currentOrders,
            },
          )}
        </>
      );
    }
    return (
      <>
        {$t(
          {
            id: 'audit.aod.actions.orderReprocess.completed',
            defaultMessage: 'Orden {orderId} reprocesada',
          },
          { orderId: currentOrders },
        )}
      </>
    );
  }

  if (isMultiple) {
    return (
      <>
        {$t(
          {
            id: 'audit.aod.actions.orderReprocess.multiple',
            defaultMessage: 'Reprocesar {count} órdenes',
          },
          { count: totalOrders },
        )}
      </>
    );
  }

  return (
    <>
      {$t(
        {
          id: 'audit.aod.actions.orderReprocess',
          defaultMessage: 'Reprocesar orden {orderId}',
        },
        { orderId: currentOrders },
      )}
    </>
  );
}
